export default "mutation RequestLicenseKeyForm($request: RequestLicenseKeyFormInput!) {\n  requestLicenseKeyForm(request: $request)\n}";